import training from './training'

const pages = { training }

export default pages
